import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { AuthService } from 'src/app/shared/services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class SummaryService {
  constructor(private http: HttpClient, private authService: AuthService) { }

  private url(path: string): string {
    const base =
      this.authService.getOriginCurrency() !== 'BRL'
        ? environment.intlUrl
        : environment.apiUrl;

    return `${base}${path}`;
  }

  getTransactionsExtrato(
    dateIni: string,
    dateEnd: string
  ): Observable<any> {
    let queryParams = new HttpParams();
    queryParams = queryParams.append('StartDate', dateIni);
    queryParams = queryParams.append('EndDate', dateEnd);

    return this.http.get(this.url('/getTransactionDetailWithdrawDeposit'), {
      params: queryParams,
    });
  }

  exportDataPdf(startDate: string, endDate: string) {
    return this.http.post<any>(this.url('/reports/resume'), {
      startDate,
      endDate,
    });
  }
}